'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var core = require('@emotion/core');

var React = require('react');

var React__default = _interopDefault(React);
/** @jsx jsx */


var ButtonIcon = React__default.forwardRef(function (_a, ref) {
  var children = _a.children,
      className = _a.className,
      iconSize = _a.iconSize;
  return core.jsx("span", {
    className: className,
    ref: ref,
    css: core.css({
      alignItems: "center",
      // This needs to be `inline-flex` and not the default of
      // `inline-block` to vertically center the icon automatically
      display: "inline-flex",
      height: iconSize,
      justifyContent: "center",
      // The `4px` will be on the right to separate the icon from the text
      width: iconSize
    })
  }, children);
});
exports.ButtonIcon = ButtonIcon;